<template>
  <div class="page-content">
    <div>
         <el-button type="primary"  @click="showCertificateView.show = true">注册CA证书</el-button>
          <!-- <el-button type="" >使用教程</el-button> -->
    </div>
    <!-- 数据展示区域 -->
    <div class="showDataView">
      <el-table
        border
        :data="certificateList"
        tooltip-effect="dark"
        style="width: 100%">
        <template slot="empty">
          <div class="emptyView">
            <div><img :src="emptyImg" class="emptyImg" alt="" srcset=""></div>
            <div>
              <p>尚未注册任何 CA 证书</p>
              <p>您可以在物联网平台上注册自己的 CA 证书，已注册的证书可用于对设备证书的校验。</p>
              <div>
                 <el-button type="primary" size="small" @click="showCertificateView.show = true">注册CA证书</el-button>
                  <el-button type=""  size="small" >使用教程</el-button>
              </div>
            </div>
          </div>
        </template>
        <el-table-column
          prop="certName"
          label="证书名称">
        </el-table-column>
         <el-table-column
          prop="certId"
          label="证书 ID">
        </el-table-column>
         <el-table-column
          prop="effectTime"
          label="生效时间">
        </el-table-column>
         <el-table-column
          prop="expiredTime"
          label="过期时间">
        </el-table-column>
         <el-table-column
          label="操作">
          <template slot-scope="scope">
            <div>
              <span class="link" @click="goDetail(scope.row)">查看</span>
              <span class="link" @click="del(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 注册CA证书弹窗 -->
    <certificateView
    v-on:close-view="certificateViewClose"
      :showCertificateView="showCertificateView">
    </certificateView>
  </div>
</template>
<script>
import emptyImg from '@img/empty.png'
import certificateView from '@/components/product_control/certificateView'
import { certList, delCertificate } from '@/api/productControl'
export default {
  components: {
    certificateView
  },
  data () {
    return {
      certificateList: [
        // { name: '文件名', id: '5555', time: '2012-10-12', endTime: '2012-12-12' }
      ],
      emptyImg: emptyImg,
      showCertificateView: {
        show: false
      }
    }
  },
  methods: {
    certificateViewClose () {
      this.showCertificateView.show = false
      this.getCertList()
    },
    goDetail (row) {
      console.log('row:', row)
      this.$router.push({
        path: '/productControl/certificateDetail',
        query: {
          registerCertId: row.registerCertId
        }
      })
    },
    getCertList () {
      const params = {}
      certList(params).then(res => {
        res = res.data
        this.certificateList = res.data
        console.log('返回的列表：', res)
      })
    },
    del (row) {
      const that = this
      this.$confirm('确定删除此证书?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        console.log(8888)
        that.confirmDel(row)
      }).catch(() => {
        console.log('进入catch')
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    confirmDel (row) {
      console.log('confirmDel:', row)
      const params = {
        registerCertId: row.registerCertId,
        flag: 0
      }
      delCertificate(params).then(res => {
        res = res.data
        console.log('删除返回res：', res)
        res.code === 200
          ? (
            this.$message({
              message: '删除成功',
              type: 'success'
            }),
            this.getCertList()
          )
          : this.$message.error(res.message)
      })
    }
  },
  created () {
    this.getCertList()
  }
}
</script>
<style lang="less" scope>
.page-content{
  .showDataView{
    margin-top: 10px;
    .link{
      color: #35a6df;
      cursor: pointer;
      margin-left: 10px;
    }
  }
  .emptyView{
    display: flex;
    align-items: center;
    text-align: left;
    line-height: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
    .emptyImg{
        width: 70px;
      }
  }

}
</style>
